<template>
  <button type="button" class="toolbarBtn"
    :class="{active: active}"
    @mousedown.prevent
    @click.stop="onClick">
    <img src="~@/assets/img/CITEditor/italic.svg" alt="italic" title="italic" />
  </button>
</template>

<script>
export default {
  name: 'Italic',
  props: [
    'active',
    'tag'
  ],
  methods: {
    onClick () {
      document.execCommand('Italic', false)
      setTimeout(() => {
        const active = this.checkTag()
        this.$emit('setActive', { name: 'Italic', active: active })
      })
    },
    checkTag () {
      const selection = window.getSelection()
      const nodeName = selection.focusNode.parentNode.nodeName.toLowerCase()
      const isActive = this.tag.includes(nodeName)
      return isActive
    }
  }
}
</script>
